import { render, staticRenderFns } from "./packages_list_loader.vue?vue&type=template&id=3ea5f189&"
import script from "./packages_list_loader.vue?vue&type=script&lang=js&"
export * from "./packages_list_loader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports